import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { Spinner } from '../components/spinner';
import * as serviceWorker from '../serviceWorker';
import { useFeedback } from '../hooks/use-feedback';
import { getFromStore, putToStore } from '../utils/indexedDB';
import { useFeedbackGames } from '../hooks/use-feedback-game';
import { FeedbackDocumentState } from '../types/feedback-document';
import { useFeedbackDocument } from '../hooks/use-feedback-document';

const FeedbackDocumentContext = React.createContext<
  [
    initialState: FeedbackDocumentState,
    setState: React.Dispatch<React.SetStateAction<FeedbackDocumentState>>
  ]
>([{}, () => {}]);

interface FeedbackDocumentProviderProps {
  feedbackCode: string;
  children: React.ReactNode;
}

const FeedbackDocumentProvider = ({
  feedbackCode,
  ...props
}: FeedbackDocumentProviderProps) => {
  const navigate = useNavigate();
  const feedbackEntity = useFeedback(feedbackCode);
  const feedbackDocument = useFeedbackDocument(feedbackCode);
  const feedbackGames = useFeedbackGames(feedbackCode);

  const [state, setState] = useState<FeedbackDocumentState>({
    feedbackCode
  });

  const loadServiceWorker = async () => {
    await new Promise((r) => {
      serviceWorker.register({ onSuccess: (e) => console.log(e) });
    });
  };

  useEffect(() => {
    loadServiceWorker();
    const loadFeedbackDocument = async () => {
      const feedback = await getFromStore<FeedbackDocumentState>(
        'feedback-document',
        feedbackCode
      );
      if (feedback && feedback.feedback) {
        setState(feedback);
      } else {
        navigate(`/feedbacks/${feedbackCode}`);
        const content: FeedbackDocumentState = {
          feedbackCode: feedbackCode,
          feedback: feedbackEntity.data,
          feedbackDocument: feedbackDocument.data,
          eventGames: feedbackGames.data
        };
        setState(content);
        putToStore('feedback-document', content);
      }
    };

    loadFeedbackDocument();
  }, [feedbackCode]);

  return (
    <FeedbackDocumentContext.Provider value={[state, setState]}>
      {state.feedbackDocument ? props.children : <Spinner />}
    </FeedbackDocumentContext.Provider>
  );
};

export { FeedbackDocumentContext, FeedbackDocumentProvider };
